module.exports = __webpack_public_path__ + "Roboto-Italic.93b13a58dedeebe51984.ttf";


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/assets/font/Roboto-Italic.ttf
// module id = ../../../../../src/assets/font/Roboto-Italic.ttf
// module chunks = styles